module.exports = __webpack_public_path__ + "img/gokaku.3f7abe40.png";